<template>
    <transition
        :enter-active-class="`transition-opacity ease-in-out duration-1000 ${enterClass}`"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        :leave-active-class="`transition-opacity ease-in-out duration-300 ${leaveClass}`"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <slot />
    </transition>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'FadeAnimation',
    props: {
        enterClass: {
            type: String,
            default: '',
        },
        leaveClass: {
            type: String,
            default: '',
        },
    },
});
</script>
